






































































































































































































































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BdSwitch from '@/components/bd-switch';
import { IOnShareTimeForm, onShareTimeFormDefault, IOnShareTimeFormArr, onShareTimeFormArrDefault } from './type';

Vue.filter('filterIndex', (val: number) => {
  return `${val < 9 ? '0' + (val + 1) : 1 + val}<=`;
});

@Component({
  components: { BdSwitch }
})
export default class SplitTimeRule extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop()
  onShareTimeForm!: IOnShareTimeForm;
  // = onShareTimeFormDefault
  @Prop()
  onShareTimeFormArr!: IOnShareTimeFormArr[];
  // = onShareTimeFormArrDefault

  // @Watch('onShareTimeForm', {
  //   deep: true,
  //   immediate: true,
  // })
  // onShareTimeFormChange() {
  //   debugger
  // }

  formAdd(array: IOnShareTimeFormArr[]) {
    const length = array.length;
    const lastFirstItem = array[length - 1];
    const lastFirstTotalMinutes = Number(lastFirstItem.hour) * 60 + lastFirstItem.minutes;
    if (lastFirstTotalMinutes <= 0) {
      this.$message.error('时长不能为空');
      return false;
    }
    if (length > 1) {
      const lastSeconodItem = array[length - 2];
      const lastSecondTotalMinutes = Number(lastSeconodItem.hour) * 60 + lastSeconodItem.minutes;

      if (lastSecondTotalMinutes >= lastFirstTotalMinutes) {
        this.$message.error('本段时长不能小于上一段');
        return false;
      }
    }
    if (length < 24) {
      array.push({ hour: '', minutes: 0, money: 0 });
    }
  }
  formRemove(arr: IOnShareTimeFormArr[]) {
    if (arr.length > 1) {
      arr.pop();
    } else {
      this.$message.error('分段计费最少要有一个时间段!');
    }
  }

  // 分时计费111
  addShareTime() {
    try {
      if (
        this.onShareTimeForm &&
        this.onShareTimeForm.limitMoneyOfDefines.length > 0 &&
        this.onShareTimeForm.limitMoneyOfDefines[this.onShareTimeForm.limitMoneyOfDefines.length - 1].limitTime !== 0 &&
        this.onShareTimeForm.limitMoneyOfDefines[this.onShareTimeForm.limitMoneyOfDefines.length - 1].money !== 0
      ) {
        this.onShareTimeForm.limitMoneyOfDefines.push({ limitTime: 0, money: 0 });
      } else {
        return this.$message.warning('请填写完整');
      }
    } catch (e) {
      console.log(e);
    }
  }
  delShareTime(index: number) {
    try {
      if (this.onShareTimeForm && this.onShareTimeForm.limitMoneyOfDefines.length > 1) {
        this.onShareTimeForm.limitMoneyOfDefines.splice(index, 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
}
